import { AxiosInstance } from "axios"
import { ApiResponse } from "../../models/api"
import { Team } from "../../models/team"

export interface GetTeamsParams {
    limit?: number
    page?: number
    paginate?: boolean
}

export class TeamsApi {
    private client: AxiosInstance

    constructor(client: AxiosInstance) {
        this.client = client
    }

    getTeams = (params?: GetTeamsParams) =>
        this.client.get<ApiResponse<Team>>("teams", {
            params: {
                limit: params?.limit ?? 20,
                page: params?.page ?? 1,
                paginate: params?.paginate ?? false,
            },
        })
}
